import V from 'voUtils/V.js';

import {
	isBlank,
	objectIsSimilar
}
from 'voUtils/tools.js';

import {
	fireSearch
}
from 'voUtils/TagEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	getVoucher
}
from 'voUtils/VoucherStore.js';
import {
	getAbTest
}
from 'voUtils/AbTest.js';

import {
	getFavIds
}
from 'voUtils/FavStore.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

import DateEx from 'voUtils/DateEx.js';

const MAX_SEARCH_RESULTS = (VOFFICE.searchOptions && VOFFICE.searchOptions.max) || 18;
const DEFAULT_SEARCH = {
	adults: 0,
	children: 0,
	babys: 0,
	petsCount: 0,
	from: undefined,
	till: undefined,
	name: undefined,
	region: '',
	seadistance_max: '',
	bedrooms_min: '',
	fc_facility: '',
	bathrooms_min: '',
	type: '',
	floor_id: '',
	facilityid: '',
	facilityname: ''
};

export default {
	voMsgCodes: [
		'guest.pl',
		'pet.pl'
	],

	data: {
		searchData: Object.assign({}, DEFAULT_SEARCH),
		ignoreDateHint: false,
		searchFields: {},
		sorting: 'random',
		extended: false,
		searching: false,
		highlightUnit: undefined,
		mapSelectedUnit: {},
		view: 'list',
		forceMap: false,
		units: [],
		mapUnits: [],
		broaderSearchResults: undefined,
		ids: [],
		resultCount: 0,
		facilityResults: [],
		currentPage: 0,
		pageCount: 0,
		lastSearch: undefined,
		error: undefined,
		showAdvancedFilters: false,
		offerError: false,
		lastOffer: undefined

	},
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('results');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}

		var addSearchFieldByOptionList = (id) => {
			this.searchFields[id] = {
				options: {}
			};
			let elements = this.$el.querySelectorAll('[data-' + id + '-id]');
			for (let el of elements) {
				this.searchFields[id].options[el.getAttribute('data-' + id + '-id')] = el.textContent;
			}
		};

		addSearchFieldByOptionList('sorting');
		addSearchFieldByOptionList('region');
		addSearchFieldByOptionList('facility');
		//addSearchFieldByOptionList('facilityname');

		var addSearchFieldLabel = (id, label) => {
			this.searchFields[id] = {
				label: label
			};
		};

		addSearchFieldLabel('favorites', this.voMsg('favorites'));
		addSearchFieldLabel('ids', this.voMsg('yourchoice'));
		addSearchFieldLabel('offers', this.voMsg('specialoffers'));
		addSearchFieldLabel('offer', this.voMsg('specialoffer'));

		var searchPanel = document.getElementById('searchpanel');
		if (searchPanel) {
			searchPanel.querySelectorAll('[v-model]').forEach((el) => {

				let field = el.getAttribute('v-model');
				let label;
				let fields = this.searchFields;

				if (field.startsWith('searchData.')) {
					field = field.substring(11);

					label = el.getAttribute('data-label');

					if (!label && el.getAttribute('id')) {
						let labelFor = searchPanel.querySelector("label[for='" + el.getAttribute('id') + "']");
						if (labelFor) {
							label = labelFor.textContent;
						}
					}

					if (!label) {
						let placeholder = el.querySelector('[placeholder]');
						if (placeholder) {
							label = placeholder.getAttribute('placeholder');
						}
					}

					if (!label) {
						let disabled = el.querySelector('[disabled][selected]');
						if (disabled) {
							label = disabled.textContent;
						}
					}

					if (label) {
						fields[field] = {
							label: label
						};

						if (el.tagName == 'SELECT') {
							fields[field].options = {};
							el.querySelectorAll('option').forEach((o) => {
								let val = o.getAttribute('value');
								if (val) {
									fields[field].options[val] = o.textContent;
								}
							});
						}


					} else {
						V.logWarn("no label found for", field, "use <label for=''>, placeholder, a disabled option or attribute 'data-label'");
					}

				}


			});

		}

		//V.log("this.searchFields", this.searchFields);



		window.addEventListener('hashchange', (e) => {
			console.log('The hash has changed!', e);
			this.updateSearchDataByUrl();
			this.goSearch();
		}, false);


		this.updateSearchDataByUrl();
		if (this.resultFields) {
			this.goSearch();

		}


	},
	updated: function () {
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
		/*$('#sidemap ').affix({
			offset: {
				top: 100
			}
		});*/

		$('.dropdown-menu.keep-open').on('click', function (e) {
			e.stopPropagation();
		});

		if (1) {
			$('body').attr('tabindex', '0');
		} else {
			alertify.confirm().set({
				'reverseButtons': true
			});
			alertify.prompt().set({
				'reverseButtons': true
			});
		}
	},
	computed: {
		mapItems: function () {
			return this.view == 'map' ? this.mapUnits : this.units;
		},
		periodLabel: function () {
			let label = '';
			if (this.searchData.from) {
				label = this.voFormatDate(this.searchData.from, 'withDay');
			}
			if (this.searchData.till) {
				label += ' - ' + this.voFormatDate(this.searchData.till, 'withDay');
			}

			if (this.searchData.from && this.searchData.till && this.searchData.nights_min) {
				let nights = DateEx.getDays(this.searchData.till, this.searchData.from);
				if (nights !== this.searchData.nights_min) {
					label += ', ' + this.searchData.nights_min;
					if (this.searchData.nights_min != this.searchData.nights_max) {
						label += ' - ' + this.searchData.nights_max;
					}
					label += ' ' + this.voMsgPl('night.pl', this.searchData.nights_max);
				}
			}


			return label;
		},
		guestLabel: function () {
			var sd = this.searchData;
			var amount = ((sd.adults || 0) - 0) + ((sd.children || 0) - 0) + ((sd.babys || 0) - 0);
			var label = amount + ' ' + this.voMsgPl('guest.pl', amount);
			if (sd.petsCount) {
				label += ', ' + sd.petsCount + ' ' + this.voMsgPl('pet.pl', sd.petsCount);

			}
			return label;
		},


		regionLabel: function () {
			return this.searchFields.region.options[this.searchData.region];
		},

		facilityLabel: function () {
			return this.searchFields.facility.options[this.searchData.facilityid];
		},

		sortingLabel: function () {
			return this.searchFields.sorting.options[this.sorting || 'random'];
		},
		searchUrl: {
			cache: false,
			get() {
				var sd = this.searchData;

				var url = 's#';
				if (sd.region) {
					url += '/' + sd.region;
				}

				var searchKeys = Object.keys(sd).sort();
				var params = [];
				for (let sp of searchKeys) {
					if (!isBlank(sd[sp]) && sp != 'region') {
						params.push(sp + '=' + sd[sp]);
					}
				}

				if (this.sorting && this.sorting != 'random') {
					params.push('sort=' + this.sorting);
				}

				if (this.view && this.view != 'list') {
					params.push('view=' + this.view);
				}

				if (params.length) {
					url += '?' + params.join('&');
				}
				return url;
			}
		},
		canGoMore: function () {
			return !this.searching && this.ids.length > (this.currentPage + 1) * MAX_SEARCH_RESULTS;
		},
		offerWarning: function () {

			//console.log('OfferWarning', this.lastOffer);

			if (this.lastOffer && !this.units.length && !this.searching && this.searchData.offerid) {
				var str = '';
				var strBtn = '<div style="margin-top:20px"><a href="./angebote"';
				strBtn += ' class="btn btn-go">Zurück zur Angebotsseite <i class="fas fa-angle-double-right"></i></a></div>';
				this.offerError = false;
				if (this.lastOffer.minStay) {

					var diffDays = DateEx.getDays(this.searchData.till, this.searchData.from);

					//console.log('diffDays', diffDays, 'Minstay', this.lastOffer.minStay);

					if (diffDays < parseInt(this.lastOffer.minStay)) {
						str += 'Deine Reisedauer unterschreitet die Mindestmietdauer des Angebotes';

						this.offerError = true;
						return str;

					}

				}

				if (this.lastOffer.timeSpan) {
					const today = DateEx.interfaceFormat(DateEx.getToday());
					let diff = DateEx.getDays(this.searchData.from, today);
					if (this.lastOffer.type === 'LASTMINUTE') {
						if (diff > parseInt(this.lastOffer.timeSpan)) {
							this.offerError = true;
							str += 'Zwischen der Buchung und Anreise dürfen nur maximal ' + this.lastOffer.timeSpan + ' liegen';
							str += strBtn;
							return str;
						}
					}
					if (this.lastOffer.type === 'EARLYBIRD') {
						if (diff < parseInt(this.lastOffer.timeSpan)) {
							this.offerError = true;
							str += 'Zwischen der Buchung und Anreise müssen mindestens ' + this.lastOffer.timeSpan + ' liegen';
							str += strBtn;
							return str;
						}
					}
				}

				if (this.lastOffer.dates && this.lastOffer.dates[0]) {

					//Date1: Bis wann das Angebot gilt
					const d1 = this.lastOffer.dates[0].till;
					//console.log('d1', d1);
					const [tag, monat, jahr] = d1.split(".");
					const date1 = new Date(2000 + parseInt(jahr), parseInt(monat) - 1, parseInt(tag));
					console.log('date1', date1);

					//Date4: Ab wann das Angebot gilt
					const d4 = this.lastOffer.dates[0].from;
					//console.log('d4', d1);
					const [tag1, monat1, jahr1] = d4.split(".");
					const date4 = new Date(2000 + parseInt(jahr1), parseInt(monat1) - 1, parseInt(tag1));
					//console.log('date1', date1);

					// Date 2: Suchdatum von
					const d2 = this.searchData.from;
					const date2 = new Date(d2);
					//console.log('date2', date2);

					// Date 3: Suchdatum bis
					const d3 = this.searchData.till;
					const date3 = new Date(d3);
					//console.log('date3', date3);
					// Wenn das Anreisedatum hinter dem Angebotsende liegt
					if (date2 > date1) {
						this.offerError = true;
						str += 'Dein Reisezeitraum liegt außerhalb des Angebotszetraum.';
						str += strBtn;
						return str;
					}
					// Wenn das Abreisedatum vor dem Angebotsende liegt
					if (date3 < date4) {
						this.offerError = true;
						str += 'Dein Reisezeitraum liegt außerhalb des Angebotszetraum.';
						str += strBtn;
						return str;
					}

				}

			}

		},
		offerCondition: function () {
			if (this.lastOffer) {
				var str = '';
				//{ "id": 15177, "name": "Zeit für Meer", "type": null, "discountType": "PERCENT", "minStay": 4, "timeSpan": null, "value": 2000, "dates": [ { "from": "02.11.25", "till": "27.12.25" } ] }
				const co = this.lastOffer;
				if (co.name) {
					str += "<strong>Angebot: " + co.name + "</strong><br/>";
				}
				if (co.dates[0].from || co.dates[0].till) {
					str += 'Gültig: ';
				}
				if (co.dates[0].from) {
					str += "vom " + co.dates[0].from + " ";
				}
				if (co.dates[0].till) {
					str += "bis " + co.dates[0].till;
				}
				if (co.minStay) {
					str += "<br/>Mindesaufenthalt: " + co.minStay + ' Nächte';
				}
				if (co.type && co.type === 'LASTMINUTE' && co.timeSpan) {
					if (co.timeSpan > 1) {
						str += "<br/>Anreise muss in spätestens " + co.timeSpan + " Tagen erfolgen";
					}
					if (co.timeSpan === 1) {
						str += "<br/>Anreise muss in spätestens in einem Tag";
					}
				}
				if (co.type && co.type === 'EARLYBIRD' && co.timeSpan) {
					str += "<br/>Anreise darf frühestens in " + co.timeSpan + " Tagen erfolgen";

				}
				return str;
			}

		}

	},
	methods: {

		showOfferInformation: function () {
			var offerId = this.searchData.offerid ? this.searchData.offerid : null;
			var result = false;

			this.offerName = null;
			this.offerMinStay = null;
			this.offerFromdate = null;
			this.offerTilldate = null;
			this.offerDiscountType = null;
			this.offerValue = null;
			this.offerTimeSpan = null;
			this.offerType = null;

			if (offerId) {
				var units = this.units;

				for (var i = 0; i < units.length; i++) {
					var unit = units[i];

					this.dates = [];

					for (var i2 = 0; i2 < unit.offers.length; i2++) {
						var offer = unit.offers[i2];

						if (offer.id == offerId) {
							const offerObj = {
								id: offer.id,
								name: offer.name || null,
								type: offer.type || null,
								discountType: offer.discountType || null,
								minStay: offer.minStay || null,
								timeSpan: offer.timeSpan || null,
								value: offer.value || null,
								dates: []
							};
							var offerDateRange = {
								from: '',
								till: ''
							};
							if (offer.name) {
								this.offerName = offer.name;
							}
							if (offer.type) {
								this.offerType = offer.type;
							}
							if (offer.discountType) {
								this.offerDiscountType = offer.discountType;
							}
							if (offer.minStay) {
								this.offerMinStay = offer.minStay;
							}
							if (offer.timeSpan) {
								this.offerTimeSpan = offer.timeSpan;
							}
							if (offer.value) {
								this.offerValue = offer.value;
							}
							if (offer.tilldate) {
								offerDateRange.till = DateEx.formatDate(offer.tilldate, undefined, VOFFICE.mlang);
							}
							if (offer.fromdate) {
								offerDateRange.from = DateEx.formatDate(offer.fromdate, undefined, VOFFICE.mlang);
							}
							if (offerDateRange) {
								offerObj.dates.push(offerDateRange);
							}
							this.dates.push(offerDateRange);
							this.lastOffer = offerObj;
						}

						result = true;

					}
				}
			}
			return result;

		},
		showAdvanced: function () {
			this.showAdvancedFilters = true;
		},
		hideAdvancedFilters: function () {
			this.showAdvancedFilters = false;
		},
		setView: function (id) {
			this.view = id || 'list';

			this.updateSearchResults();
		},
		toggleUnitOnMap: function (u) {
			if (this.mapSelectedUnit == u) {
				this.closeMap();
			} else {
				this.forceMap = true;
				this.$nextTick(function () {
					this.mapSelectedUnit = u;
				});
			}
		},
		closeMap: function () {
			this.mapSelectedUnit = {};
			this.forceMap = false;
		},
		hasMoreFacilityResults: function (u) {
			if (u.facility && this.facilityResults[u.facility] && this.facilityResults[u.facility] > VOFFICE.searchOptions.groupFacilities) {
				return true;
			}
		},
		selectRegion: function (id) {
			this.searchData.region = id;
		},
		selectFacility: function (id) {
			this.searchData.facilityid = id;
		},
		toggleBalconyTerrace: function (id) {
			if ($('#' + id).is(":checked")) {
				if (id == 'Balcony') {
					this.searchData.terrace = undefined;
				}
				if (id == 'Terrace') {
					this.searchData.balcony = undefined;
				}
			}
		},
		setSorting: function (id, event) {
			this.sorting = id;
		},
		getSortingLabel: function () {
			if (this.sorting == 'price') {
				return 'Preis';
			} else if (this.sorting == 'beachdistance') {
				return 'Entfernung zum Strand';
			} else if (this.sorting == 'citydistance') {
				return 'Entfernung zum Stadt-/Dorfkern';
			} else if (this.sorting == 'squareMeters') {
				return 'Größe der Unterkunft nach m²';
			}
		},
		setSortingAndRefresh: function (id) {
			this.sorting = id;
			this.updateSearchResults();
		},
		setSearchParamAndRefresh: function (id, val) {
			//this.searchData[id] = val;
			this.$set(this.searchData, id, val);
			this.updateSearchResults();
		},
		setPetFilter: function (id, uniqueId) {
			if (id == 'cb_pets') {
				if ($('#cb_pets').is(":checked")) {
					this.searchData.pets = 'true';
					$('#cb_nopets').prop('checked', false);
				} else {
					this.searchData.pets = '';
				}
			} else if (id == 'cb_nopets') {
				if ($('#cb_nopets').is(":checked")) {
					this.searchData.pets = 'false';
					$('#cb_pets').prop('checked', false);
				} else {
					this.searchData.pets = '';
				}
			}
			this.$forceUpdate();
		},
		resetFilter: function () {
			this.searchData = Object.assign({}, DEFAULT_SEARCH);
			this.updateSearchResults();
		},
		updateSearchDataByUrl: function () {

			this.searchData = Object.assign({}, DEFAULT_SEARCH);

			var req = this.parseUrl();
			this.sorting = req.sorting;
			this.view = req.view || 'list';

			var reg = /^\d+$/;
			for (let k in req.filter) {
				this.$set(this.searchData, k, (reg.test(req.filter[k]) && parseInt(req.filter[k], 10)) || req.filter[k]);
			}

		},
		parseUrl: function () {

			var req = {
				fields: this.resultFields,
				filter: {},
				sorting: 'random'
			};

			var hash = window.location.hash;
			if (hash) {
				hash = hash.substring(1);

				let url = new URL(hash, 'https://www.v-office.com');
				let params = new URLSearchParams(url.search);

				if (url.pathname.length > 1) {
					req.filter.region = url.pathname.substring(1);
				}

				for (let p of params) {
					if (p[0] == 'view') {
						req.view = p[1];
					} else if (p[0] == 'sort') {
						req.sorting = p[1];
					} else {
						req.filter[p[0]] = p[1];
					}
				}
			}

			if (VOFFICE.searchOptions) {
				Object.assign(req, VOFFICE.searchOptions);
			}

			if (VOFFICE.abtest) {
				req.abtest = VOFFICE.abtest;
			}

			return req;
		},
		updateSearchResults: function () {
			var url = this.searchUrl;
			history.pushState({

			}, "", url);

			this.goSearch();
		},
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				//probably phone?
				return '_self';
			} else {
				return 'unit_' + id;
			}

		},
		getUnitSearchPath: function (path, o) {
			var sd = this.searchData;

			var searchKeys = ['from', 'till', 'adults', 'children', 'babys', 'pets', 'petsCount'];
			var params = [];
			for (let sp of searchKeys) {
				if (o && o[sp]) {
					params.push(sp + '=' + o[sp]);
				} else if (!isBlank(sd[sp])) {
					params.push(sp + '=' + sd[sp]);
				}
			}

			if (params.length) {
				path += '#?' + params.join('&');
			}
			return path;


		},
		goSearch: function () {

			if (this.lastUrl && this.lastUrl == this.searchUrl) {
				//V.log("no url change!");
			} else {
				let req = this.parseUrl();
				this.doSearchNow(req);
			}


		},
		showMore: function () {
			this.searching = true;

			var req = Object.assign({}, this.lastSearch);

			var shown = (this.currentPage + 1) * MAX_SEARCH_RESULTS;
			if (this.ids.length > shown) {
				req.ids = this.ids.slice(shown, Math.min(this.ids.length, shown + MAX_SEARCH_RESULTS));
				this.error = undefined;
				doReq('searchUnits', req)
					.then((res) => {
						this.units = this.units.concat(res.units);
						this.currentPage += 1;
						this.searching = false;
					})
					.catch(e => {
						this.searching = false;
						this.error = e;
					});


			} else {
				//V.logWarn('no more results');
				this.searching = false;
			}

		},

		setPage: function (page) {
			//V.log("setPage", page);
			page--;
			this.units = [];
			this.searching = true;

			var req = Object.assign({}, this.lastSearch);

			var start = page * MAX_SEARCH_RESULTS;
			req.ids = this.ids.slice(start, Math.min(this.ids.length, start + MAX_SEARCH_RESULTS));
			this.error = undefined;
			doReq('searchUnits', req)
				.then((res) => {
					this.units = res.units;
					this.currentPage = page;
					this.searching = false;
					$('html, body').animate({
						scrollTop: $("#contentStart").offset().top
					}, 2000);
				})
				.catch(e => {
					this.searching = false;
					this.error = e;
				});


		},
		doSearchNow: function (req) {
			this.units = [];
			this.searching = true;

			if (req.filter.favorites) {
				delete req.filter.favorites;
				req.filter.ids = getFavIds();
			}

			if (req.view == 'map') {
				req.mapsearch = true;
			}
			var voucher = getVoucher();
			if (voucher) {
				req.voucherCode = voucher.code;
			}
			if (getAbTest()) {
				req.abtest = getAbTest();
			}


			this.lastUrl = this.searchUrl;
			this.error = undefined;

			doReq('searchUnits', req)
				.then((res) => {
					//V.log("res", res);

					this.lastSearch = req;
					this.searching = false;

					if (req.mapsearch) {
						this.mapUnits = res.units;

						this.units = [];
						this.ids = [];
						this.resultCount = res.units.length;


					} else {

						this.units = res.units;
						this.broaderSearchResults = res.broaderSearchResults;
						this.ids = res.ids;
						this.facilityResults = res.facilityResults || [];
						this.currentPage = 0;
						this.pageCount = Math.ceil(this.ids.length / MAX_SEARCH_RESULTS);

						this.resultCount = res.total || this.ids.length;

						if (this.$refs.mysearch) {
							this.$refs.mysearch.update();
						}
						if (this.$refs.pagination) {
							this.$refs.pagination.overwriteCurrentPage(1);
						}
					}
					fireSearch(this.resultCount, req);
					/*$('html, body').animate({
						scrollTop: $("#contentStart").offset().top
					}, 2000);*/

				})
				.catch(e => {
					this.searching = false;
					this.error = e;
				});
		}
	},
	watch: {
		mapSelectedUnit: function (nv) {
			//V.log("mapSelectedUnit", nv);
			if (nv && nv.lazy) {

				var req = {
					fields: this.resultFields,
					filter: this.lastSearch.filter,
					ids: [nv.info[2]]
				};


				doReq('searchUnits', req)
					.then((res) => {
						//this.units = res.units;
						if (res.units && res.units.length) {
							Object.assign(nv, res.units[0]);
							nv.lazy = false;
						}

					});

			}
		}
	}

};